module.exports = __webpack_public_path__ + "static/media/app_store.d5c3e1a7.png";